import React, {useMemo} from 'react';
import {useSelector} from "react-redux";
import DataTable from "react-data-table-component";
import customStyles from "../TableStyles";
import ComponentCard from "../ComponentCard";

const CommissionSlabDetail = (details) => {

    const isDarkMode = useSelector((state) => state.customizer.isDark);

    const columns = useMemo(() => [
        {
            name: 'Range Start',
            selector: row => row.rangeStart,
            sortable: true,
            width: '180px',
            wrap: true,
            reorder: true,
            filterable: true,
        },
        {
            name: 'Range End',
            selector: row => row.rangeEnd,
            sortable: true,
            width: '180px',
            wrap: true,
            reorder: true,
            filterable: true,
        },
        {
            name: 'Percentage',
            selector: row => `${row.percentage}%`,
            sortable: true,
            width: '180px',
            wrap: true,
            reorder: true,
            filterable: true,
        },
        {
            name: 'Status',
            selector: row => row.status,
            sortable: true,
            width: '120px',
            wrap: true,
            reorder: true,
            filterable: true,
        },
        {
            name: 'Name',
            selector: row => row.name,
            sortable: true,
            width: '300px',
            wrap: true,
            reorder: true,
            filterable: true,
        },
        {
            name: 'Code',
            selector: row => row.code,
            sortable: true,
            width: '120px',
            wrap: true,
            reorder: true,
            filterable: true,
        },
    ]);

    return (
        <ComponentCard>
            <DataTable
                columns={columns}
                data={details.data[1]}
                noTableHead
                striped
                dense
                fixedHeader
                fixedHeaderScrollHeight='500px'
                theme={isDarkMode ? 'iDark' : 'iLight'}
                customStyles={customStyles}
            />
        </ComponentCard>
    );
};

export default CommissionSlabDetail;
